import { render, staticRenderFns } from "./DeliveryReceiptReceives.vue?vue&type=template&id=6cafe142&"
import script from "./DeliveryReceiptReceives.vue?vue&type=script&lang=js&"
export * from "./DeliveryReceiptReceives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports